import { DateTime } from './luxon.js'


export function isItToday(dt) {
    return DateTime.now().hasSame(
        dt,
        'day'
    )

}

export function isItYesterday(dt) {
    return DateTime.now().minus({ day: 1 }).hasSame(
        dt,
        'day'
    )
}

export function isItTomorow(dt) {
    return DateTime.now().plus({ day: 1 }).hasSame(
        dt,
        'day'
    )
}

export function isItThisWeek(dt) {
    return DateTime.now().hasSame(
        dt,
        'week'
    )
}
export function isItThisYear(dt) {
    return DateTime.now().hasSame(
        dt,
        'year'
    )
}

export function humanDate(timestamp, justeTheDate = false, locale = 'en') {

    let datetime = DateTime.fromJSDate(new Date(timestamp))

    // console.warn('locale', locale, this)

    if (justeTheDate) {
        if (isItToday(datetime)) {
            if (!this.$vt) {
                return `Today`
            }
            return this.$vt(`Today`)
        }
        else if (isItYesterday(datetime)) {
            if (!this.$vt) {
                return `Yesterday`
            }
            return this.$vt(`Yesterday`)
        }
        else if (isItTomorow(datetime)) {
            if (!this.$vt) {
                return `Tomorrow`
            }
            return this.$vt(`Tomorrow`)
        }
        else if (isItThisYear(datetime)) {


            let format = Object.assign({}, DateTime.DATE_MED, {
                month: 'long',
                hour12: false
            })
            delete format.year
    
            return datetime.setLocale(locale).toLocaleString(format)
    
        }

        return datetime.setLocale(locale).toLocaleString(Object.assign({}, DateTime.DATE_MED, {
            hour12: false
        }))
    }

    if (isItToday(datetime)) {
        let time = datetime.setLocale(locale).toLocaleString(DateTime.TIME_24_SIMPLE)
        return `Today at ${time}`
    } else if (isItYesterday(datetime)) {
        let time = datetime.setLocale(locale).toLocaleString(DateTime.TIME_24_SIMPLE)
        return `Yesterday at ${time}`
    }
    else if (isItThisYear(datetime)) {


        let format = Object.assign({}, DateTime.DATETIME_MED, {
            month: 'long',
            hour12: false
        })
        delete format.year

        return datetime.setLocale(locale).toLocaleString(format)

    }


    return datetime.setLocale(locale).toLocaleString(Object.assign({}, DateTime.DATETIME_MED, {
        hour12: false
    }))



}